import {Component, OnInit, ViewChild} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';
import {InputComponent} from '../../components/input/input.component';
import {GMapService} from "../../services/g-map.service";
import {Pos} from "../../model/PosModel";

@ComponentAsElement('v-list-of-cities-element')
@Component({
  selector: 'v-list-of-cities',
  templateUrl: './list-of-cities.component.html',
  styleUrls: []
})
export class ListOfCitiesComponent implements OnInit {
  @ViewChild(InputComponent, {static: true}) private inputComponent: InputComponent;
  selectChoiced: boolean;
  items: (null|string)[] = [];
  selectItems: (null|string)[] = [];
  filteredItems: (null|string)[] = [];
  selectedCity = '';
  showSelect = false;
  geolocationDeny = false;
  firstGeoRequest = true;

  constructor(private gMapService: GMapService) {

  }

  ngOnInit() {
    this.getCities();
    this.gMapService.currentCity.subscribe(city => this.selectedCity = city);
    this.gMapService.geoRunner.subscribe((_geo) => {

      if(this.firstGeoRequest) {
        this.firstGeoRequest = !this.firstGeoRequest;
        return;
      }

      if(!_geo) {
        this.geolocationDeny = true;
        setTimeout(()=>{
          this.geolocationDeny = false;
          },
        4000)
      }
      else {
        this.geolocationDeny = false;
      }
    });
  }

  private getCities() {
    this.items = [];

    this.gMapService.poses.subscribe( items => {
      items.forEach( (item: Pos) => {
        const city = item?.address?.town ? item.address.town : 'undefined';

        if (this.items.indexOf(city) === -1) {
          this.items.push(city);
        }
      });
      this.items.sort(Intl.Collator().compare);
      this.selectItems = [...this.items];
      this.assignCopy();
      this.showSelect = true;
    });

  }

  assignCopy() {
    this.filteredItems = [...this.items];
  }

  filterItem(_cityName: string) {
    this.filteredItems = Object.assign([], this.items).filter(
      item => {
        return item?.toLowerCase().indexOf(_cityName.toLowerCase()) > -1;
      }
    );
  }

  onChangedInput(_event) {
    this.filterItem(_event);
  }

  onEnterVal(_value) {
    const value = _value;
    const firstItem = this.filteredItems[0];

    if(this.filteredItems.length === 1 && firstItem.toLowerCase() === value.toLowerCase()) {
      this.newCity(firstItem);
    }
  }

  onChangeSelect(_event) {
    const event = _event;

    this.selectedCity = event;
    this.selectChoiced = true;
    this.newCity(this.selectedCity);
  }

  newCity(_selectedCity) {
    this.selectedCity = _selectedCity;

    this.gMapService.changeCity(this.selectedCity);
  }

  runGeolocalization() {
    this.gMapService.runGeo(true);
    this.selectedCity = '';
  }
}
